import axios from './axiosInstance';

export const addService = async ({
  data
}) => {
  try{
    const response = await axios({
      url : '/add-service',
      method : 'POST',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const listService = async ({
  page,
  limit,
  search
}) => {

  let params = {};

  if(page !== null){
    params.page = page
  }
  if(limit){
    params.limit = limit
  }
  if(search){
    params.search = search
  }
  try{
    const response = await axios({
      url : '/list-service',
      method : 'GET',
      params : params
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const updateService = async ({
  data,
  id
}) => {
  try{
    const response = await axios({
      url : `/update-service/${id}`,
      method : 'PUT',
      data : data
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}

export const getService = async ({
  id
}) => {
  try{
    const response = await axios({
      url : `/get-service/${id}`,
      method : 'GET'
    })

    return({
      data : response.data,
      error : null
    })

  }catch(error){
    return{
      data : null,
      error : error
    }
  }
}